import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";

import { IonicModule } from "@ionic/angular";

import { ReportsPageRoutingModule } from "./reports-routing.module";
import { GeneralPageModule } from "./tab-general/tab-general.module";
import { CashierPageModule } from "./tab-cashier/tab-cashier.module";

import { ReportsPage } from "./reports.page";

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    ReportsPageRoutingModule,
    GeneralPageModule,
    CashierPageModule,
  ],
  declarations: [ReportsPage],
})
export class ReportsPageModule {}
